import { ChangeDetectionStrategy, Component, effect, EventEmitter, input, Output, untracked } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { map, startWith, switchMap } from 'rxjs/operators';
import { DynamicFormComponent } from '@app/shared/components/dynamic-form/dynamic-form.component';
import { DynamicFormControl } from '@app/shared/components/dynamic-form/model/dynamic-form-control.model';
import { DynamicFlowRawFormValues } from '../../model/dynamic-flow.types';

@Component({
  selector: 'c-form-step',
  imports: [DynamicFormComponent],
  templateUrl: './form-step.component.html',
  styleUrl: './form-step.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormStepComponent {
  formStructure = input.required<DynamicFormControl[]>();
  dynamicForm = input.required<FormGroup>();
  title = input<string>();
  showErrors = input<boolean>(false);

  @Output() formChanged = new EventEmitter<DynamicFlowRawFormValues | null>();

  constructor() {
    toObservable(this.dynamicForm)
      .pipe(
        switchMap((form) => form.valueChanges.pipe(startWith(null), map(() => form))),
        takeUntilDestroyed(),
      )
      .subscribe((form) => this.formChanged.emit(form.valid ? (form.getRawValue() as DynamicFlowRawFormValues) : null));

    // Form controls only show errors for touched fields
    effect(() => {
      if (this.showErrors()) {
        untracked(() => this.dynamicForm().markAllAsTouched());
      }
    });
  }
}
